// extracted by mini-css-extract-plugin
module.exports = {"btn":"index-module--btn--3VFj-"};